import React from "react";

import { LinkPill } from "./linkPill";

import { ReactComponent as ZendeskLogo } from "static/images/zendesk_logo.svg";

type ZendeskButtonProps = {
	value: string;
	disabled: boolean;
	onClick?: React.MouseEventHandler<HTMLElement>;
};

export const ZendeskButton = ({
	value,
	disabled,
	onClick,
}: ZendeskButtonProps) => {
	return (
		<LinkPill
			icon={<ZendeskLogo />}
			label={value}
			onClick={onClick}
			disabled={disabled}
		/>
	);
};
